export default __webpack_public_path__ + "static/media/Substrates-Hub.bb6bda7c.svg";